import AbsSection from '../AbsSection';
import NoMovieVisual from '../moviePlayer/NoMovieVisual';
import MovieItem from './MovieItem';
import InfoBox from './InfoBox';
import Util from '../../common/Util';

class MoviePlayerB extends AbsSection {
    constructor(_container='', _dataM={}, _option={}){
        super(_container, _dataM, _option, 'moviePlayerB');

        this.nameIs = 'class-MoviePlayerB Main App';

        if( this.isShow ) {
            this.dataM.addManual('moviePlayer', this.com.ip + '-main-recom');
        } else {
            $('section.main-movie .main-movie-visual').addClass('is-active');
            this.noMovie = new NoMovieVisual('section.main-movie .main-movie-visual', this.option);
        }
    }

    init(){
        if( !this.isShow ) return false;

        if(!Util.objHasKeys( window, ['YT', 'Player'] )){
            window.onYouTubeIframeAPIReady = () => this.setTemplate();
            var tag = document.createElement('script');
                tag.src = "https://www.youtube.com/iframe_api";
            document.head.appendChild(tag);
        } else {
            this.setTemplate();
        }
    }

    setTemplate(){
        // console.log( '!!', this.dataM.data.moviePlayer );

        this.info = new InfoBox();

        this.itemList = [];
        let item = {};
        const itemListTempl = this.dataM.data.moviePlayer.map( (it, idx) => {
            item = new MovieItem(it, idx, this.container);
            this.itemList.push( item );
            return item.templ();
        }).join('');

        const templ = `
<ul class="centertype-list">${itemListTempl}</ul>
<div class="info-box">${this.info.templ()}</div>
<button type="button" class="slick-btn-prev"></button>
<button type="button" class="slick-btn-next"></button>
<div class="paging centertype-paging">
    <span class="paging-count"><em class="is-active">1</em> / ${this.dataM.data.moviePlayer.length}</span>
</div>`;


        $( this.container ).html( templ );
        $( this.container ).addClass('is-active');

        this.itemList.map( it => it.init() );

        this.nowMovieItem = this.itemList[0];
        this.info.update(this.nowMovieItem.data.title, this.nowMovieItem.data.id);

        this.movieSL = $('.centertype-list').slick({
            dots: false,
            arrows: true,
            infinite: true,
            slidesToScroll: 1,
            prevArrow: $('.slick-btn-prev'),
            nextArrow: $('.slick-btn-next'),
            centerMode: true,
            centerPadding: '70px',
            responsive: [
                {
                    breakpoint: 1260,
                    settings: {
                        centerPadding: '124px'
                    }
                },
                {
                    breakpoint: 960,
                    settings: {
                        dots: true,
                        appendDots: $('.info-box .dots'),
                        arrows: false,
                        centerMode: false

                    }
                }
            ]
        });

        this.addEventsTypeB();
    }
    
    addEventsTypeB(){
        this.movieSL.on('beforeChange', (event, slick, currentSlide, nextSlide)=>{
            this.nowMovieItem = this.itemList[nextSlide];
            this.itemList.map( it => it.stop() );
            this.nowMovieItem.play();

            this.info.update(this.nowMovieItem.data.title, this.nowMovieItem.data.id);
            $('.main-movie-centertype .centertype-paging .is-active').html(nextSlide+1);
        });

        this.movieSL.on('breakpoint', (event, slick, breakpoint)=>{
            console.log( 'breakpoint', breakpoint );
        });

        $(this.container).on('ITEM_PLAY_END', (e)=>{
            this.movieSL.slick( 'slickNext' );
        })

        $(`.main-movie-centertype`).on( 'PLAYER_INIT_COMP', (e)=>{
            if (window.innerWidth < 960) return false;
            if (e.videoId === this.nowMovieItem.data.youtubeId) {
                this.nowMovieItem.play();
            }
        });
    }


} // end of class
export default MoviePlayerB;